import Card, { CardContent } from '@/components/card';
import { Link } from '@/components/link';
import TextStack, {
  TextLabel,
  TextStackItem,
  TextValue
} from '@/components/text-stack';
import { PlanService } from '@/services/Plan.service';
import { Divider, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { FC, useContext } from 'react';

import { AlertContext } from '../../../contexts/AlertContext';
import { CardHeader } from '../common/CardHeader.component';

export const DisbursementInformation: FC = () => {
  const alert = useContext(AlertContext);

  const planId = alert.metadata?.planIds?.[0] || alert.details?.planId;

  const getPlanQuery = useQuery(
    ['PlanService.getPlanById', planId],
    () => PlanService.getPlanById(planId),
    {
      enabled: !!planId
    }
  );

  return (
    <Card size='small'>
      <CardHeader title='Information' />
      <Divider />
      <CardContent>
        <Stack flex={1}>
          <Typography variant='h6'>
            {getPlanQuery.data?.data.attributes.name}
          </Typography>
          {planId && (
            <Link target='_blank' to={`/plans/${planId}/plan`}>
              Plan ID: {planId}
            </Link>
          )}
          <TextStack direction='column'>
            <TextStackItem>
              <TextLabel>Sponsor ID</TextLabel>
              <TextValue>
                {getPlanQuery.data?.data?.relationships?.sponsor?.data?.id}
              </TextValue>
            </TextStackItem>
            <TextStackItem>
              <TextLabel>Recordkeeper</TextLabel>
              <TextValue>
                {getPlanQuery.data?.data?.relationships?.recordKeeper?.data?.id}
              </TextValue>
            </TextStackItem>
          </TextStack>
        </Stack>
      </CardContent>
    </Card>
  );
};

DisbursementInformation.displayName = 'DisbursementInformation';
